import { useContext, useEffect } from 'react';
import { DragCtx } from '../contexts';

/**
 * useDragEndReset — registers a reset function so any component can call
 * resetAll() to clear every drop-line in the tree synchronously inside
 * the drop/dragend handler.
 * In preview mode, ctx._resets is a no-op Set so this is harmless.
 */
export function useDragEndReset(reset) {
  const ctx = useContext(DragCtx);
  useEffect(() => {
    if (!ctx?._resets) return;
    ctx._resets.add(reset);
    return () => ctx._resets.delete(reset);
  }, [ctx, reset]);
}